import { IFeature } from 'types'
import { FEATURE_NAME } from './Standings.model'

export const StandingsFeature: IFeature = {
  title: FEATURE_NAME,
}
